export namespace AuthenticationErrorConstants {
  export const ACCOUNT_NOT_VERIFIED: RegExp = /account not verified/;
  export const DISABLED: RegExp = /account disabled/;
  export const BAD_CREDENTIALS: RegExp = /bad credentials/;
  export const LOCKED: RegExp = /account locked/;
  export const ROLE_NOT_FOUND: RegExp = /bad role/;
  export const ACCOUNT_EXPIRED: RegExp = /account expired/;
}
